module.exports = __webpack_public_path__ + "img/wine-1.831e6a96.jpg";